import { initialListPaginationMeta } from "utils/helpers/pagination";

import { SuperModelForm, SuperModelState } from "../types";

export const initialSuperModelForm: SuperModelForm = {
  name: "",
  manufacturer: "",
  priority: "",
};

export const initialSuperModelMeta = initialListPaginationMeta;

export const initialState: SuperModelState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialSuperModelMeta,
  error: null,
  manufacturerFilter: "ALL",
  isAddModalOpen: false,
  form: initialSuperModelForm,
};
